// extracted by mini-css-extract-plugin
export default {"home":"Home_home__CMw1J","blocks":"Home_blocks__yhwAQ","inputBlocks":"Home_inputBlocks__x006g","saveBtn":"Home_saveBtn__7aCEb","pagination":"Home_pagination__ZsoLg"};